import { createSlice } from "@reduxjs/toolkit";
import { toGetTerms } from "../actions/terms.actions";

const initialState = {
  terms: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const termsSlice = createSlice({
  name: "terms",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetTerms.pending, (state) => {
      state.terms = { list: [], status: "idle" };
    });
    builder.addCase(toGetTerms.fulfilled, (state, action) => {
      state.terms = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetTerms.rejected, (state, action) => {
      state.terms = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default termsSlice.reducer;
